import { parseChatEmbeds, type ChatDataTableEmbed, type ChatEmbed, type ChatEntitySearchResultsEmbed } from "./types";

export function searchEmbedsFromSegment(embeds: unknown): ChatEntitySearchResultsEmbed[] {
  const parsed = parseChatEmbeds(embeds);
  return parsed.filter((embed): embed is ChatEntitySearchResultsEmbed => embed.kind === "entity_search_results");
}

/** True when the embeds segment only carries search cards (paired with the preceding tool step). */
export function isSearchOnlyEmbedsSegment(embeds: unknown): boolean {
  const parsed = parseChatEmbeds(embeds);
  return parsed.length > 0 && parsed.every((embed) => embed.kind === "entity_search_results");
}

export function canMergeToolStepWithFollowingSearchEmbeds(
  toolSegment: { type?: string },
  followingEmbeds: unknown,
): boolean {
  if (toolSegment.type !== "tool_step") {
    return false;
  }
  return isSearchOnlyEmbedsSegment(followingEmbeds);
}

export function nonSearchEmbeds(embeds: ChatEmbed[]): ChatEmbed[] {
  return embeds.filter((embed) => embed.kind !== "entity_search_results");
}

export function dataTableEmbedsFromSegment(embeds: unknown): ChatDataTableEmbed[] {
  const parsed = parseChatEmbeds(embeds);
  return parsed.filter((embed): embed is ChatDataTableEmbed => embed.kind === "data_table");
}

/** True when the embeds segment only carries data tables (paired with the preceding tool step). */
export function isDataTableOnlyEmbedsSegment(embeds: unknown): boolean {
  const parsed = parseChatEmbeds(embeds);
  return parsed.length > 0 && parsed.every((embed) => embed.kind === "data_table");
}

export function canMergeToolStepWithFollowingDataTableEmbeds(
  toolSegment: { type?: string },
  followingEmbeds: unknown,
): boolean {
  if (toolSegment.type !== "tool_step") {
    return false;
  }
  return isDataTableOnlyEmbedsSegment(followingEmbeds);
}
